import * as actions from './types/actions';
import * as mutations from './types/mutations';
import AudioBookService from './../../../services/audio-book-service/AudioBookService'

export default {
    [actions.GET_AUDIO_BOOK]: async ({ commit, dispatch }, id) => {
        try {
            const audioBook = await AudioBookService.getAudioBookById(id);
            commit(mutations.SET_AUDIO_BOOK, audioBook);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.UPDATE_AUDIO_BOOK]: async ({ commit, dispatch }, id) => {
        try {
            const audioBook = await AudioBookService.updateAudioBook(id);
            commit(mutations.SET_AUDIO_BOOK, audioBook);
        } catch (error) {
            dispatch(error);
        }
    },
    [actions.DELETE_AUDIO_BOOK]: async ({ commit, dispatch }, id) => {
        try {
            await AudioBookService.deleteAudioBook(id);
        } catch (error) {
            dispatch(error);
        }
    }
};